import { Link } from '@chakra-ui/react';

import { useLayoutContext } from 'context/LayoutContext';
import { classNames } from 'utils/classNames';

import { AnimatedTextWord } from './AnimatedTextWord';
import { Text } from 'components/v4';
import TCAPLogoLight from '@/assets/images/Logo_white.png';
import getRuntimeAppConfig from '@/utils/runtimeAppConfig';

const appConfig = getRuntimeAppConfig();

export const SidebarAppVersion = () => {
    const { isMenuCollapse, touched: isCollapseBtnTouched } =
        useLayoutContext();
    const TCAPLogo = TCAPLogoLight;
    const currentYear = new Date().getFullYear();

    return (
        <div className={isMenuCollapse ? 'pl-1' : 'pl-[0.8rem]'}>
            <div className="flex items-center">
                {!isMenuCollapse && isCollapseBtnTouched ? (
                    <AnimatedTextWord text="Powered by" />
                ) : (
                    <Text
                        color="white"
                        fontSize="sm"
                        as="span"
                        className={isMenuCollapse ? 'hidden' : 'inherit'}>
                        Powered by &nbsp;
                    </Text>
                )}
                <img
                    style={{
                        paddingLeft: isMenuCollapse ? 1 : 3,
                        marginLeft: isMenuCollapse ? -2.5 : 0,
                    }}
                    className="h-[26px] w-auto"
                    src={TCAPLogo}
                    alt="TCAP Logo"
                />
            </div>
            <div
                className={classNames(
                    `${isMenuCollapse ? 'hidden' : 'inherit'}`,
                    'flex bg-none text-xs',
                )}>
                <Text color="white" as="span">
                    &copy; {currentYear} - TCAP
                </Text>
                <Link
                    href="https://roadmap.pingco.com.au/updates"
                    target="_blank"
                    _hover={{ textDecoration: 'none' }}
                    className="text-white hover:text-inherit hover:no-underline">
                    &nbsp;{appConfig.version}
                </Link>
            </div>
        </div>
    );
};
